import { InitData } from '../../server/data/BaseModel';
import { PresentationState } from '../../../dev/gameflow/controller/Presentation';
import { SetupFlow } from './SetupFlow';

export class SetupRestoreFlow extends SetupFlow {

    private gameSize:number = 3;

    checkForActivation(data: InitData): boolean { return data.isRestoreState && (data.mode === "FREESPIN_SETUP"); }

    // This badboy will define if it is a restore.
    setInitData(data: InitData): void {
        if(data.isRestoreState && (data.mode === "FREESPIN_SETUP")){
            super.setGamedData(data);
            this.PresentationState.set(PresentationState.ACTIVATED);
            this.gameSize = data.Reel.worldSize;
        }
    }

    // preStart(): void {
    //     if(this.gameData.Reel.fsInfo.isUTURN){
    //         RoadRage.reelManager.forcedRestoreSizeChange(this.gameSize,true);
    //         RoadRage.backgroundElements.forceBackground(this.gameSize);
    //     }
    //     super.preStart();
    // }
 
}